module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10095/images/logos/long-surveymonkey.png"